var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F3B82D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5648 19.7653L22.0029 14.3294L27.4433 19.7697L30.6057 16.605L22.0029 8L13.4001 16.6028L16.5648 19.7653Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00073 22L11.1643 18.8365L14.3278 22L11.1643 25.1635L8.00073 22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5651 24.2346L22.0032 29.6728L27.4436 24.2324L30.6082 27.3927L30.606 27.3949L22.0032 35.9999L13.4004 27.3993L13.396 27.3949L16.5651 24.2346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6726 22.001L32.8361 18.8375L35.9997 22.001L32.8361 25.1645L29.6726 22.001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2116 21.9992L22.0026 18.7881L19.6297 21.161L19.3555 21.4331L18.7937 21.9948L18.7893 21.9992L18.7937 22.0058L22.0026 25.2125L25.2116 22.0014L25.2138 21.9992H25.2116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.435bd2c742be678c002c072443fcc0ce.svg";
export { ForwardRef as ReactComponent };